import { useEffect, useContext } from "react"
import { Box, Stack, TextField, Typography, Grid, FormControl, Select, MenuItem, Button } from "@mui/material"
import { ArrowBack } from "@mui/icons-material"
import { useHistory } from "react-router-dom"
import { fieldStyle } from "../../../../../core/global/realproperty/Index"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { rqx } from "../../../../../core/request/API"
import { env } from "../../../../../core/Env"
import { SnakeLoader } from "../../../../../core/loader/SnakeLoader"
import { Confirmation } from "../../../../../core/global/Confirmation"
import { SuccessMsg } from "../../../../../core/global/SuccessMsg"
import { Appointment } from "./Appointment"
import { Requirement } from "./Requirement"
import { S3 } from "../../../../../core/transmit/S3"

export const Index = () => {
    const { realproperty_state, tool_state } = useContext(ToolContext);
    const { inquiryData, statuses, inquiryForm, appntmntForm, fileTypes, requirements } = realproperty_state;
    const d = inquiryData.data?.data[0]
    const pid = new URLSearchParams(window.location.search).get('pid')
    const currentStatus = new URLSearchParams(window.location.search).get('s')
    const nav = useHistory();
    const classes = fieldStyle();

    const __init = async () => {
        try {
            inquiryData.set((p) => ({ ...p, loader: true }))   
            const data = await rqx.get(`<<tool>>/${env()}/propertyListing/read_spcfc_inquiry`, { id: window.atob(pid).split('_').pop() });
            inquiryData.set((p) => ({ ...p, loader: false, data }))
            inquiryForm.set((p) => ({ ...p, 
                status: { ...p.status, value: data[0].property_inquiry_status === 4 ? 8 : data[0].user_property_requirement_id ? 7 : data[0].appointment_status === 1 ? 4 : data[0].appointment_status === 2 ? 5 : data[0].appointment_status === 3 ? 6 : data[0].property_inquiry_status  },
                description: { ...p.description, value: data[0].description || '' },
                reason_for_rejection: { ...p.reason_for_rejection, value: data[0].reason_for_rejection || '' }
            }))
            if ( data[0].appointment_status === 1 || data[0].appointment_status === 2 || data[0].appointment_status === 3) {
                const dateTime = data[0].appointment_schedule.split(" "); 
                appntmntForm.set((p) => ({ ...p, 
                    date: { ...p.date, value: dateTime[0] || '' },
                    time: { ...p.time, value: dateTime[1].slice(0, 5) || '' },
                    reason_for_cancelled: { ...p.reason_for_cancelled, value: data[0].appointment_reason_for_cancelled || '' }
                }))
            }
            nav.push(`/realproperty/property-inquiries?method=update&pid=${pid}&s=${getStatusTxt(data[0])}`)
        } catch (error) {
            console.error(error);
        }
    }

    const getStatusTxt = (id) => {
        if (id.property_inquiry_status === 4) return 'deal-closed';
        if (id.user_property_requirement_id) return 'requirements-saved';
        const appointmentMap = ['appointment-scheduled', 'appointment-completed', 'appointment-cancelled'];
        const inquiryMap = ['for-inquiry', 'declined', 'approved'];
        return appointmentMap[id.appointment_status - 1] ??
                inquiryMap[id.property_inquiry_status - 1] ??
                'unknown-status';
    };

    const handleBack = () => {
        appntmntForm.set((p) => ({
            ...p,
            date: { value: '', stat: false, msg: 'Date is required!' },
            time: { value: '', stat: false, msg: 'Time is required!' },
            reason_for_cancelled: { value: '', stat: false, msg: 'Reason is required!' },
        }))
        nav.push(`/realproperty/property-inquiries`, { shouldReload: true });
    }

    const handleModal = (type) => {
        if ((currentStatus === 'for-inquiry' && inquiryForm.data.status.value === 2) || 
            (currentStatus === 'for-inquiry' && inquiryForm.data.status.value === 3) ||
            (currentStatus === 'declined' && inquiryForm.data.status.value === 3) ||
            (currentStatus === 'approved' && inquiryForm.data.status.value === 2)) {
            if ((inquiryForm.data.status.value === 2 && inquiryForm.data.reason_for_rejection.value.trim() === '') || (inquiryForm.data.status.value === 3 && inquiryForm.data.description.value.trim() === '')) {
                inquiryForm.set((p) => ({
                    ...p,
                    description: { ...p.description, stat: inquiryForm.data.status.value === 3 && inquiryForm.data.description.value.trim() === '' },
                    reason_for_rejection: { ...p.reason_for_rejection, stat: inquiryForm.data.status.value === 2 && inquiryForm.data.reason_for_rejection.value.trim() === '' }
                }))
                return;
            }
        }
        if (currentStatus === 'approved' && inquiryForm.data.status.value === 4) {
            if (inquiryForm.data.status.value === 4 && (appntmntForm.data.date.value.trim() === '' || appntmntForm.data.time.value.trim() === '')) {
                appntmntForm.set((p) => ({
                    ...p,
                    date: { ...p.date, stat: appntmntForm.data.date.value.trim() === '' },
                    time: { ...p.time, stat: appntmntForm.data.time.value.trim() === '' }
                }))
                return;
            }
        }
        if (currentStatus === 'appointment-scheduled' && inquiryForm.data.status.value === 6) {
            if (inquiryForm.data.status.value === 6 && appntmntForm.data.reason_for_cancelled.value.trim() === '') {
                appntmntForm.set((p) => ({
                    ...p,
                    reason_for_cancelled: { ...p.reason_for_cancelled, stat: appntmntForm.data.reason_for_cancelled.value.trim() === '' },
                }))
                return;
            }
        }
        if ((currentStatus === 'appointment-completed' || currentStatus === 'requirements-saved')  && inquiryForm.data.status.value === 7 ) {
            const sellerReq = fileTypes.data.sellerAvailReq.filter(v => v.file)
            const buyerReq = fileTypes.data.buyerAvailReq.filter(v => v.file)
            const currSellerReq = fileTypes.data.sellerAvailReq.filter(v => v.existing_file)
            const currBuyerReq = fileTypes.data.buyerAvailReq.filter(v => v.existing_file)
            const curr = [ ...currSellerReq, ...currBuyerReq ]
            const req = [ ...sellerReq, ...buyerReq ]
            const combine = [ ...curr, ...req ]
            if (combine.length === 0) {
                requirements.set((p) => ({
                    ...p,
                    error: true,
                }))
                return;
            }
        }
        inquiryData.set((p) => ({ ...p, modal: type === 'open' }))   
    }

    const submitUpdate = async (endpoint, body) => {
        try {
            inquiryData.set((p) => ({ ...p, sendLoader: true }))
            const u = await rqx.post(`<<tool>>/${env()}${endpoint}`, body)
            if (u.message === 'success' || u.message === 'update_not_needed') {
                inquiryData.set((p) => ({ ...p, sendLoader: false, success: true, modal: false }))
                __init();
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleSubmit = async () => {
        if ((currentStatus === 'for-inquiry' && inquiryForm.data.status.value === 2) || 
            (currentStatus === 'for-inquiry' && inquiryForm.data.status.value === 3) ||
            (currentStatus === 'declined' && inquiryForm.data.status.value === 3) ||
            (currentStatus === 'approved' && inquiryForm.data.status.value === 2) || (currentStatus === 'requirements-saved' && inquiryForm.data.status.value === 8)) {
            inquiryData.set((p) => ({ ...p, sendLoader: true }))
            const body = {
                id: Number(window.atob(pid).split('_').pop()),
                user_id: tool_state.userId.data,
                status: inquiryForm.data.status.value === 8 ? 4 : inquiryForm.data.status.value,
                description: inquiryForm.data.status.value === 3 ? inquiryForm.data.description.value : '',
                reason_for_rejection: inquiryForm.data.status.value === 2 ? inquiryForm.data.reason_for_rejection.value : '',
                active: inquiryData.data.active
            }
            await submitUpdate('/propertyListing/update_properties_inquiries', body);     
        }
        if (currentStatus === 'approved' && inquiryForm.data.status.value === 4) {
            inquiryData.set((p) => ({ ...p, sendLoader: true }))
            const body = {
                property_inquiry_id: d?.property_inquiry_id,
                listing_location_id: d?.listing_location_id,
                time: appntmntForm.data.time.value,
                date: appntmntForm.data.date.value,
                status: inquiryForm.data.status.value === 4 ? 1 : inquiryForm.data.status.value === 5 ? 2 : 3 ,
                reason: appntmntForm.data.reason_for_cancelled.value,
                user_id: tool_state.userId.data,
            }
            await submitUpdate('/propertyListing/create_appointment', body);
        }
        if ((currentStatus === 'appointment-scheduled' && ( inquiryForm.data.status.value === 5 || inquiryForm.data.status.value === 6 )) ||
            (currentStatus === 'appointment-cancelled' && inquiryForm.data.status.value === 4)) {
            inquiryData.set((p) => ({ ...p, sendLoader: true }))
            const body = {
                appointment_id: d?.appointment_id,
                time: appntmntForm.data.time.value,
                date: appntmntForm.data.date.value,
                status: inquiryForm.data.status.value === 4 ? 1 : inquiryForm.data.status.value === 5 ? 2 : 3 ,
                reason_for_cancelled: appntmntForm.data.reason_for_cancelled.value,
                user_id: tool_state.userId.data,
            }
            await submitUpdate('/propertyListing/update_appointment', body);
        }       
        if ((currentStatus === 'appointment-completed' || currentStatus === 'requirements-saved')  && inquiryForm.data.status.value === 7 ) {
            inquiryData.set((p) => ({ ...p, sendLoader: true }))
            const sellerReq = fileTypes.data.sellerAvailReq.filter(v => v.file)
            const buyerReq = fileTypes.data.buyerAvailReq.filter(v => v.file)
            const currSellerReq = fileTypes.data.sellerAvailReq.filter(v => v.existing_file)
            const currBuyerReq = fileTypes.data.buyerAvailReq.filter(v => v.existing_file)
            const curr = [ ...currSellerReq, ...currBuyerReq ]
            const req = [ ...sellerReq, ...buyerReq ]
            const combine = [ ...curr, ...req ]
            const upldReq = await Promise.all (
                combine.map(async (v) => {
                    if (v.existing_file) {
                        return {
                            user_requirement_id: v.existing_file.user_requirement_id,
                            company_property_requirement_id: v.company_property_requirement_id,
                        }
                    }
                    const getLink = await S3(v.file.file);
                    return {
                        property_requirement_id: v.id,
                        company_property_requirement_id: v.company_property_requirement_id,
                        file_owner_type: v.type,  
                        file_link: getLink.location,
                        file_name: v.file.file[0].name,
                        file_type: v.file.file[0].type,
                        file_size: v.file.file[0].size,
                    };
                })
            )
            const body = {
                user_property_requirement_id: fileTypes.data.existing_upr_id || '',
                company_id: tool_state.__SESSION.data.uaccess[0].company_id,
                listing_id: d.listing_id,
                seller_company_user_id: tool_state.userId.data,
                buyer_user_id: d.buyer_user_id,
                property_inquiry_id: d.property_inquiry_id,
                files: upldReq,
            }
            await submitUpdate('/propertyListing/create_requirements', body);
        } 
    }
    const generateStatuses = () => {
        const s = statuses.data.filter(v => {
            if (d?.user_property_requirement_id) {
                return [7, 8].includes(v.id);
            } else if (d?.appointment_status === 1) {
                return [4, 5, 6].includes(v.id);
            } else if (d?.appointment_status === 2) {
                return [5, 7].includes(v.id);
            } else if (d?.appointment_status === 3) {
                return [4, 6].includes(v.id);
            } else if (d?.property_inquiry_status === 1 || d?.property_inquiry_status === 2) {
                return [1, 2, 3].includes(v.id);
            } else if (d?.property_inquiry_status === 3) {
                return [1, 2, 3, 4].includes(v.id);
            }
            return false; 
        })
        return (
            s.map((v, k) => (
                <MenuItem key={k} value={v.id}>{v.name}</MenuItem>
            )) 
        )
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        inquiryForm.set((p) => ({ 
            ...p, 
            [name]: {
                ...p[name],
                value,
                stat: name !== 'status' && value.trim() === ""
            }
        }))
    }

    useEffect(() => (
        __init()
        // eslint-disable-next-line
    ), [])

    return (
        <Box pt="1rem">
            <Stack direction="row" gap="1rem" alignItems="center" mb="0.5rem">
                <ArrowBack onClick={() => handleBack()} sx={{ color: "primary.main", cursor: "pointer", transition: "0.25s" ,':hover': { color: "grey" }, }}/>
                <Typography fontSize="1.25rem" fontWeight="600">Review and Update Client Status.</Typography>
            </Stack>
            { inquiryData.data.loader ? 
                <Box display="flex" justifyContent="center" mt="4rem"><SnakeLoader size="12px" bg="#11783C" distance="8px" /></Box>
            :
                <>
                    <Stack direction='row' gap='2rem' mt='1rem'>
                        <Typography fontSize={14} fontWeight={600} sx={{ color: (currentStatus === 'for-inquiry' || currentStatus === 'declined' || currentStatus === 'approved') ? 'primary.main' : '#5B6167'}}>Client Qualification</Typography>
                        <Typography fontSize={14} fontWeight={600} sx={{ color: (currentStatus === 'appointment-scheduled' || currentStatus === 'appointment-completed' || currentStatus === 'appointment-cancelled') ? 'primary.main' : '#5B6167'}}>Property Viewing</Typography>
                        <Typography fontSize={14} fontWeight={600} sx={{ color: (currentStatus === 'requirements-saved' || currentStatus === 'deal-closed') ? 'primary.main' : '#5B6167'}}>Deal Closure</Typography>
                    </Stack>
                    <Grid container spacing={2} pt="1.5rem">
                        <Grid item xs={12} sm={12} md={4}>
                            <Typography mb='0.5rem'>Full Name:</Typography>
                            <TextField size="small" fullWidth className={classes.tf} value={d?.full_name} disabled/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                            <Typography mb='0.5rem'>Email:</Typography>
                            <TextField size="small" fullWidth className={classes.tf} value={d?.email} disabled/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                            <Typography mb='0.5rem'>Contact Number:</Typography>
                            <TextField size="small" fullWidth className={classes.tf} value={d?.contact_number} disabled/>
                        </Grid>
                        { inquiryForm.data.status.value !== 2 ?
                            <Grid item xs={12}>
                                <Typography mb='0.5rem'>Description of the Client:</Typography>
                                <TextField disabled={inquiryForm.data?.status.value !== 3 && inquiryForm.data?.status.value !== 1} name='description' size="small" value={inquiryForm.data.description.value} onChange={handleChange} error={inquiryForm.data.description.stat} fullWidth className={classes.tf} multiline inputProps={{ maxLength: 1000 }} sx={{ '& .MuiInputBase-input': { minHeight: '7.5rem', maxHeight: '15rem' } }}/>
                            </Grid>
                        :
                            <Grid item xs={12}>
                                <Typography mb='0.5rem'>Reason:</Typography>
                                <TextField disabled={inquiryForm.data?.status.value !== 2} name='reason_for_rejection' size="small" value={inquiryForm.data.reason_for_rejection.value} onChange={handleChange} error={inquiryForm.data.reason_for_rejection.stat} fullWidth className={classes.tf} multiline inputProps={{ maxLength: 1000 }} sx={{ '& .MuiInputBase-input': { minHeight: '7.5rem', maxHeight: '15rem' } }}/>
                            </Grid>
                        }
                        { (inquiryForm.data.status.value === 4 || inquiryForm.data.status.value === 5 || inquiryForm.data.status.value === 6 || inquiryForm.data.status.value === 7 || inquiryForm.data.status.value === 8) && <Appointment classes={classes} d={d} currentStatus={currentStatus}/>}
                        { (inquiryForm.data.status.value === 7 || inquiryForm.data.status.value === 8) && <Requirement currentStatus={currentStatus}/> }
                        <Grid item xs={12} sm={12} md={4}>
                            <Stack direction="row">
                                <Typography mb='0.5rem'>Status:</Typography>
                            </Stack>
                            <FormControl fullWidth size="small" sx={{ borderRadius: '12px', bgcolor: '#fff', '& .MuiOutlinedInput-notchedOutline': { borderRadius: '12px' } }}>
                                <Select disabled={currentStatus === 'deal-closed'} name='status' value={inquiryForm.data?.status.value} onChange={handleChange}> 
                                    {generateStatuses()}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Stack mt="4rem" alignItems='center'>
                        <Button variant="contained" size="large"  onClick={() => handleModal('open')} sx={{ width: "10rem" }} 
                            disabled={
                                inquiryForm.data.status.value === 1 || currentStatus === 'deal-closed' ||
                                (currentStatus === 'appointment-scheduled' && inquiryForm.data.status.value === 4) ||
                                (currentStatus === 'appointment-cancelled' && inquiryForm.data.status.value === 6) ||
                                (currentStatus === 'appointment-completed' && inquiryForm.data.status.value === 5)
                            }
                        > Update </Button>
                    </Stack>
                </>
            }
            { inquiryData.data.modal && <Confirmation isOpen={inquiryData.data.modal} cancel={() => handleModal('close')} send={() => handleSubmit()} disabled={inquiryData.data.sendLoader} text={'Are you sure you want to update this inquiry?'} btnText="Confirm"/> }
            { inquiryData.data.success && <SuccessMsg open={inquiryData.data.success} setOpen={(v) => inquiryData.set(p => ({ ...p, success: v }))} message="Success" bgcolor="#d2f9e2" hideDuration={null}/> }
        </Box>
    )
}
